import { ExpandRounded, MinimizeOutlined } from "@mui/icons-material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import { Box, Card } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import isFunction from "lodash/isFunction";
import { useCallback, useMemo, useState } from "react";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";

const PinnedModal = ({
  // show,
  // onClose,
  // title,
  // children,
  // description,
  // sx,
  // suppressBodyPadding,
  // suppressBodyOverflow,
  // bodySx,
  // allowFullScreen,
  // titleBottomContent,
  // fullWidth = true,
  // hideBackdrop,
  // icon,
  // maxWidth = "md",
  // autoWidth,
  // disableAutoMobile,
  // headerSx,
  // defaultFullScreen = false,

  //
  show,
  onClose,

  height = "680px",
  minHeight = "400px",
  icon,

  titleEndContent,
  title = "Comments",
  maxWidth = `540px`,

  fixed = true,
  children,
  sx,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const onModalClose = useCallback(() => {
    if (isFunction(onClose)) {
      onClose(false);
    }
  }, [onClose]);

  const cardStyles = useMemo(() => {
    const offset = 36;
    let baseStyles = {
      boxShadow: 20,
      position: fixed ? "fixed" : "absolute",
      bottom: 0,
      right: offset,
      p: 0,
      zIndex: 99999,
      width: `calc(100% - ${offset * 2}px)`,
      maxWidth: collapsed ? "325px" : maxWidth,
      display: "flex",
      flexDirection: "column",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    };

    return {
      ...baseStyles,
      ...sx,
    };
  }, [fixed, maxWidth, collapsed, sx]);

  const headerStyles = useMemo(() => {
    return {
      flexGrow: 0,
      p: collapsed ? 1 : 2,
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
      alignItems: "center",
      cursor: collapsed ? "pointer" : "default",
    };
  }, [collapsed]);

  const onHeaderExpand = useCallback(
    (props) => {
      if (!collapsed) {
        return;
      }
      setCollapsed(false);
    },
    [collapsed]
  );

  const onIconButtonClick = useCallback(() => {
    if (collapsed) {
      return;
    }
    setCollapsed(true);
  }, [collapsed]);

  if (!show) return null;

  return (
    <Card
      sx={cardStyles}
      // sx={{
      //   boxShadow: 20,
      //   position: fixed ? "fixed" : "absolute",
      //   bottom: 0,
      //   right: offset,
      //   p: 0,
      //   zIndex: 99999,
      //   width: `calc(100% - ${offset * 2}px)`,
      //   maxWidth: collapsed ? "325px" : maxWidth,
      //   display: "flex",
      //   flexDirection: "column",
      //   borderBottomLeftRadius: 0,
      //   borderBottomRightRadius: 0,
      // }}
    >
      <Box fw jb ac onClick={onHeaderExpand} sx={headerStyles}>
        <Flx ac gap={0.5}>
          {icon}
          <Txt bold>{title}</Txt>
          {titleEndContent}
        </Flx>
        <Flx ac>
          <IconButton onClick={onIconButtonClick} size="small">
            {collapsed ? <ExpandRounded /> : <MinimizeOutlined />}
          </IconButton>
          <IconButton onClick={onModalClose} size="small">
            <CloseRounded />
          </IconButton>
        </Flx>
      </Box>
      <Flx
        column
        sx={{
          overflowY: "auto",
          flexGrow: 1,
          height: collapsed ? 0 : height,
          minHeight: collapsed ? 0 : minHeight,
          maxHeight: "68vh",
          pb: collapsed ? 0 : 2,
          transition: "200ms ease-in-out",
        }}
      >
        {children}
      </Flx>
    </Card>
  );
};
export default PinnedModal;
